import type { ReactElement, SVGProps } from "react";

export function ShieldIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
      {...props}
    >
      <path d="M12 2l7 4v5c0 4.97-2.99 9.62-7 11.88C7.99 20.62 5 15.97 5 11V6l7-4z" />
    </svg>
  );
}
